import type { NavigateFunction } from 'react-router-dom-v5-compat';

import { JobChangedFM } from 'af-root/scenes/Company/WorkOrders/Order/formModel';

import type { W_Job_Create_VM } from 'ab-api/web/job/create';

import type JobUpsertVM from 'ab-viewModels/workRequest/jobUpsert.viewModel';

import JobUpsertFM, { SubjobFM } from 'af-components/SharedForms/Job/formModel';

import type { RedirectParams } from '.';

type RedirectHandlerParams = RedirectParams & { navigate: NavigateFunction; activateScrollToTopOfFormForSubjobRedirect: () => Promise<void>; };

type RedirectHandler = (
	job: JobUpsertVM,
	orgAlias: Nullable<string>,
	params: RedirectHandlerParams
) => void;

const handleJobFormRedirect: RedirectHandler = (job: W_Job_Create_VM, orgAlias: Nullable<string>, params: RedirectHandlerParams) => {
	const formJob = JobUpsertFM.fromJobCreateVM(job);
	if (!params.linkForRedirect) {
		return;
	}
	params.activateScrollToTopOfFormForSubjobRedirect?.();
	params.navigate(params.linkForRedirect, {
		state: {
			subjob: SubjobFM.fromJobUpsertFM(formJob),
			defaultDueDate: params.defaultDueDateForRedirect,
			orgAlias: orgAlias,
			previousFormState: params.previousFormStateForRedirect,
		},
	});
};

const handleWorkOrderRedirect: RedirectHandler = (job: JobUpsertVM, orgAlias: Nullable<string>, params: RedirectHandlerParams) => {
	const formJob = new JobChangedFM(job);
	if (!params.linkForRedirect) {
		return;
	}
	params.navigate(params.linkForRedirect, {
		state: {
			job: formJob,
			defaultDueDate: params.defaultDueDateForRedirect,
			orgAlias: orgAlias,
		},
	});
};

const handleDefaultRedirect: RedirectHandler = (job: W_Job_Create_VM, orgAlias: Nullable<string>, params: RedirectHandlerParams) => {
	const formJob = JobUpsertFM.fromJobCreateVM(job);
	if (!params.linkForRedirect) {
		return;
	}
	params.navigate(params.linkForRedirect, {
		state: { job: formJob, defaultDueDate: params.defaultDueDateForRedirect, orgAlias: orgAlias },
	});
};

const redirectHandlers: Record<string, RedirectHandler> = {
	'jobs/edit': handleJobFormRedirect,
	'jobs/create': handleJobFormRedirect,
	'orders/order': handleWorkOrderRedirect,
	'default': handleDefaultRedirect,
};

export function getRedirectHandler(link: string): Nullable<RedirectHandler> {
	if (!link) {
		return null;
	}
	for (const key of Object.keys(redirectHandlers)) {
		if (link.includes(key)) {
			return redirectHandlers[key];
		}
	}
	return redirectHandlers.default;
}
